import { rem } from 'polished';
import styled from 'styled-components';
import { IColors } from '../../interfaces/Conference';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(40)} 0 ${rem(15)} 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
`;

export const Title = styled.span<{ colors: IColors }>`
    padding-bottom: ${rem(30)};
    display: inline-block;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
    position: relative;
    color: ${(props) => props.colors?.colorTitle};
`;

export const TitleSymbol = styled.span<{ colors: IColors }>`
    position: absolute;
    width: ${rem(40)};
    height: ${rem(5)};
    background: ${(props) => props.colors?.colorLine};
    left: 0;
    bottom: ${rem(15)};
`;

export const Partners = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: ${rem(25)};

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
    }
`;

export const Label = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    min-width: ${rem(200)};
    padding-bottom: ${rem(25)};
`;

export const Images = styled.div``;

export const Image = styled.img`
    width: ${rem(150)};
    padding: 0 ${rem(20)} ${rem(20)} 0;
`;

export const Link = styled.a``;
